require('./home.less');
require('../../app/app');
const i18n = require('i18n');
const util = require('../../app/util');
const ajax = util.ajax;
const tpl = require('./index.html');
const uid = util.getCookie('uid');
const username = util.getCookie('username');
const pageConfig = window.pageConfig;


const commentType = +util.getQuery('t') || 1;
const commentTypeId = +util.getQuery('i') || 1;
const barWidth = +util.getQuery('w');



const showMyComment = !!(pageConfig.comment && pageConfig.comment.uid);
const isOwner = !!(pageConfig.comment && pageConfig.comment.owner == uid);
const canComment = !!(pageConfig.comment && pageConfig.comment.status === 0 && !isOwner);

if (showMyComment) {
	pageConfig.comment.created = util.format(pageConfig.comment.created);
}
const myComment = showMyComment ? pageConfig.comment : {};
const statData = pageConfig.stat || {};
const validate = pageConfig.validate;

$('body').append(tpl({
	uid,
	username,
	showMyComment,
	myComment,
	statData,
	canComment,
	showComment: (!!(pageConfig.comment && !isOwner)) && (showMyComment || canComment),
	placeholder: i18n('tip.content', {max: validate.maxContent})
}));


const rateArr = [i18n('great'), i18n('good'), i18n('ok'),  i18n('bad'), i18n('sucks')];
function makeRate(rate) {
	return rateArr.map((item, i) => {
		const active = 5 - i <= rate;
		return `<label class="full ${active ? 'active' : ''}" title="${item} - ${5 - i} stars"></label>`
	}).join('')
}
function makeWriteRate(prefix, readonly, rate) {
	return rateArr.map((item, i) => {
		return `<input type="radio" id="star${prefix}${i}" name="rating${prefix}" value="${i}" />
		<label class="full" for="star${prefix}${i}" title="${item} - ${5 - i} stars"></label>`
	}).join('')
}

;(function () {// 统计
	if (pageConfig.error || !pageConfig.stat) {
		$('.comment-stat').hide();
		return
	}
	const intPrex = Math.floor(statData.avg_rate);
	$('.comment-stat .rating').html(makeRate(intPrex));
	const ratio = $('.ratio-icon');
	if (statData.avg_rate !== intPrex) {
		ratio.css({
			left: intPrex * 25,
			width: 20 * (statData.avg_rate - intPrex)
		}).removeClass('hide');
		$('.ratio-mask').css({
			left: intPrex * 25
		}).attr('title', rateArr[4 - intPrex] + ` - ${statData.avg_rate} stars`)
	}

	const max = Math.max(statData.rate_1_count, statData.rate_2_count, statData.rate_3_count, statData.rate_4_count, statData.rate_5_count);
	let html = '';
	//const color = ['#ff6f31', '#ff9f02', '#ffcf02', '#9ace6a', '#57bb8a'];
	const color = ['#0062ff', '#0062ff', '#0062ff', '#0062ff', '#0062ff'];
	for(let i = 5; i > 0; i--) {
		const key = `rate_${i}_count`;
		html += `<div>
			<span class="line-num">${i}</span>
			<div style="position: relative; margin-bottom: ${i === 0 ? 0 : 4}px;width:${(statData[key] * 100 / max) + '%'}; background: ${color[i - 1]}; height: 15px;">
				<span class="comment-num">${statData[key] ? statData[key] + i18n('item') : '' }</span>
			</div>
		</div>`
	}
	$('.comment-stat-bar').html(html);

	if (barWidth) {
		$('.comment-stat-bar').css('flex-grow', barWidth);
	}
})();

function renderReplyContent(item, userMap) {
	const content = item.rcontent ? item.rcontent.split('\n').join('</div><div>') : '';

	return item.ruid ? `<div class="comment-reply-content">
		<span class="fw-b mr-10">${userMap[item.ruid].nickname}(${i18n('owner')})</span>
    <span class="fs-12">${util.format(item.rcreated)}</span>
    <div class="reply-content"><div>${content}</div></div>
	</div>` : '';
}
function renderReplyOp(item) {
	return isOwner ? `<div class="comment-reply-op">
			<a data-rid="${item.ruid ? item.id : ''}" data-cid="${item.id}" class="submit-reply op-btn mr-10" href="#">
			${i18n(item.ruid ? 'edit' : 'reply') }
			</a>
			<a href="#" class="cancel-rely hide op-btn">${i18n('cancel')}</a>
		</div>` : '';
}
function renderList(data) {
	const userMap = {};
	data.users.forEach((item) => {
		userMap[item.id] = item;
	});

	const html = data.comments.map((item) => {
		const content = item.content ? item.content.split('\n').join('</div><div>') : '';
		return `<li data-cid="${item.id}" class="flex mb-10">
        <div class="comment-user-avatar">
          <img src="https://user-center-assets.enhancer.io/avatar/${item.uid}/${item.uid}.png">
        </div>
        <div class="flex-1">
          <div class="flex mr-10">
            <div class="flex-1">
              <div>
                <span class="fw-b mr-10">${userMap[item.uid].nickname}</span>
                <span class="fs-12">${util.format(item.created)}</span>
              </div>
              <div class="mb-5 clearfix">
              	<fieldset class="rating">
              		${makeRate(item.rate)}
              	</fieldset>
              </div>
            </div>
            <div class="like ${isOwner ? '' : 'pointer'}">
            	<div class="mb-5">
            		<i class="fa fa-thumbs-o-up" title="${i18n('use')}"></i>
            		<span class="fs-12">(<span class="like-count">${item.like_count}</span>)</span>
            	</div>
            	<div>
            		<i class="fa fa-thumbs-o-down" title="${i18n('useless')}"></i>
            		<span class="fs-12">(<span class="like-count">${item.dislike_count}</span>)</span>
            	</div>
            </div>
          </div>
          <div class="mb-5 comment-content"><div>${content}</div></div>
         	${renderReplyContent(item, userMap)}
         	${renderReplyOp(item)}
        </div>
      </li>`
	}).join('');

	$('.comment-list ul').append(html);
}

// 加载评价列表
if (pageConfig.stat) {
	const total = Math.ceil(statData.count / validate.pageSize);
	let page = -1;
	$('#load-more').click(function (e) {
		e.preventDefault();
		
		ajax({
			url: `/${commentType}/${commentTypeId}/comments`,
			data: {
				page: page + 1
			}
		}, function (res) {
			page++;
			if (page >= total - 1) {
				$('#load-more').hide();
			}
			renderList(res.data);
			sendMsg();
		}, 'list', $('.comment-list .loader'));
	}).click();	
} else {
	$('#load-more').hide().parent().find('.no-data').removeClass('hide');
}







if (isOwner) {
	function submitReply(content, cid, rid, cb) {
		const url = rid ? `/reply/${rid}/edit` : `/comment/${cid}/reply/add`;
		ajax({
			url: url,
			data: {
				content
			},
			type: 'POST'
		}, function (res) {
			cb && cb(res);
		});
	}
	$('.comment-list').on('click', '.submit-reply', function (e) {
		e.preventDefault();
		const target = $(e.target);
		const open = target.data('open');
		const rid = target.data('rid');

		let textarea = target.parent().prev('.reply-box');
		if (open) {
			textarea.next('.error').remove();
			const content = textarea.val().trim();
			if (!content) {
				textarea.focus();
				return
			}
			if (content.length < validate.minContent) {
				////
			}
			if (content.length > validate.maxContent) {
				textarea.after('<div class="error">' + i18n('tip.content', {max: validate.maxContent}) + '</div>');
				return
			}
			submitReply(content, target.data('cid'), rid, function (res) {
				textarea.addClass('hide').val('');
				target.text(i18n('edit')).data('open', 0);
				target.parent().find('.cancel-rely').addClass('hide');
				if (rid) {
					target.closest('li').find('.reply-content').text(content);
				} else {
					const reply = renderReplyContent({
						rcontent: content,
						ruid: uid,
						rcreated: new Date()
					}, {
						[uid]: {
							nickname: username
						}
					});
					target.data('rid', target.data('cid'))
					target.closest('.comment-reply-op').before(reply);
				}
				sendMsg();
			})
		} else {
			if (!textarea.length) {
				target.parent().before(`<textarea class="reply-box" placeholder="${i18n('tip.content', {max: validate.maxContent})}" rows="5"></textarea>`);
				textarea = target.parent().prev('.reply-box')
			} 
			textarea.removeClass('hide').focus();
			target.parent().find('.cancel-rely').removeClass('hide');
			target.text(i18n('submit'));
			target.data('open', 1);
			if (rid) {
				textarea.val(target.closest('li').find('.reply-content').text())
			}
			sendMsg();
		}
	}).on('click', '.cancel-rely', function (e) {
		e.preventDefault();
		const target = $(e.target);
		const submit = target.parent().find('.submit-reply');
		const rid = submit.data('rid');
		target.addClass('hide');
		submit.text(i18n(rid ? 'edit' : 'reply')).data('open', 0);
		target.parent().prev('.reply-box').addClass('hide').val('');
		sendMsg(true);
	});
} else {
	if (showMyComment) {
		$('.container .my-commented .rating').html(makeRate(myComment.rate));
	}

	$('.container .my-comment-to .rating').html(makeWriteRate('write'))
	
	function submitComment (data) {
		const comment = pageConfig.comment;
		const edit = !!(comment && comment.id);

		const url = edit ? `/comment/${comment.id}/edit` : `/${commentType}/${commentTypeId}/comment/add`;
		if (edit) {
			data.type = commentType;
			data.typeId = commentTypeId;
			if (data.rate === pageConfig.comment.rate) {
				if (data.content === pageConfig.comment.content) {
					$('#cancel-comment').click();
					return
				}
				delete data.rate;
			}
		}
		ajax({
			url:  url,
			data: data,
			type: 'POST'
		}, function (res) {
			$('.my-comment-to').hide();
			$('.my-commented .my-comment-content').text(data.content);
			
			if (edit) {
				$('.container .my-commented .rating').html('')
				pageConfig.comment.content = data.content;
				pageConfig.comment.rate = data.rate || pageConfig.comment.rate;
				const oldItem = $('.comment-list li[data-cid=' + pageConfig.comment.id + ']');
				if (oldItem.length) {
					oldItem.find('.comment-content').text(data.content);
					oldItem.find('.rating').html(makeRate(pageConfig.comment.rate));
				}
			} else {
				if (!pageConfig.stat) {
					window.location.reload();
					return;
				}
				pageConfig.comment = data;
				pageConfig.comment.id = res.data;
				$('.my-commented .my-comment-time').text(util.format(new Date));
			}
			$('.container .my-commented .rating').html(makeRate(data.rate || pageConfig.comment.rate));
			$('.my-commented').show();
			sendMsg();
		});
	}
	$('#submit-comment').click(function (e) {
		e.preventDefault();
		const error = $('.error');
		error.addClass('hide');
		const checked = $('.my-comment-to .rating input:checked');
		if (!checked.length) {
			error.text(i18n('rate.input')).removeClass('hide');
			return
		}
		const rate = 5 - checked.val();
		const content = ($('.my-comment-to textarea').val() || '').trim();

		if (!content) {
			error.text(i18n('content.input')).removeClass('hide'); 
			return
		}
		if (content.length < validate.minContent) {
			///
		}
		if (content.length > validate.maxContent) {
			error.text(i18n('tip.content', {max: validate.maxContent})).removeClass('hide');
			return
		}

		submitComment({
			rate,
			content
		})
	});

	$('#cancel-comment').click(function(e) {
		e.preventDefault();
		$('.my-comment-to').hide();
		$('.my-commented').show();
		sendMsg();
	})

	$('.edit-my-comment').click(function (e){
		e.preventDefault();
		$('.my-commented').hide();
		$('.my-comment-to textarea').val(pageConfig.comment.content);
		$('.my-comment-to rating input:checked').prop('checked', false);
		$('.my-comment-to #starwrite' + (5 - pageConfig.comment.rate)).prop('checked', true);
		$('.my-comment-to').show();
		sendMsg();
	});

	function submitLike(like, cid, cb) {
		ajax({
			url:  `/comment/${cid}/${like ? 'like' : 'dislike'}`,
			type: 'POST',
			data: {
				type: commentType,
				typeId: commentTypeId
			}
		}, cb);
	}
	$('.comment-list').on('click', '.like i.fa', function (e) {
		e.preventDefault();
		const target = $(e.target);
		const cid = target.closest('li').data('cid');
		submitLike(target.hasClass('fa-thumbs-o-up'), cid, function (res) {
			const span = target.parent().find('span.like-count');
			const count = parseInt(span.text(), 10);
			span.text(count + (res.data.add ? 1 : -1));
		});
	}); 
}

var source;
var postOrigin;
var host = location.host.split('.');
var domain = host = 'enhancer.' + host[host.length - 1];
function sendMsg (cancel) {
	if (source) {
		setTimeout(function () {
			var height = cancel ? (document.body.clientHeight || document.documentElement.clientHeight) : calcPageHeight(document);
			source.postMessage(height + 46, postOrigin);
		}, 20)
	}
}
function calcPageHeight(doc) {
  var cHeight = Math.max(doc.body.clientHeight, doc.documentElement.clientHeight)
  var sHeight = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight)
  var height  = Math.max(cHeight, sHeight)
  return height;
}
window.addEventListener('message', function (e) {
	var origin = e.origin.split('.');
	postOrigin = e.origin;
	if (origin[origin.length - 2] + '.' + origin[origin.length - 1] === domain) {
		source = e.source;
		sendMsg();
	}	
}, false);










// WEBPACK FOOTER //
// ./src/pages/home/home.js